import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";

const StatsCards = ({ people }) => {
  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      <Grid item xs={6} sm={3}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            textAlign: "center",
            borderRadius: "12px",
            backgroundColor: "rgba(34, 139, 34, 0.9)",
            color: "white",
          }}
        >
          <PeopleIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {people.length}
          </Typography>
          <Typography variant="body2">Total Staff</Typography>
        </Paper>
      </Grid>

      <Grid item xs={6} sm={3}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            textAlign: "center",
            borderRadius: "12px",
            backgroundColor: "rgba(54, 162, 235, 0.9)",
            color: "white",
          }}
        >
          <BusinessIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {new Set(people.map((p) => p.dep_name).filter(Boolean)).size}
          </Typography>
          <Typography variant="body2">Departments</Typography>
        </Paper>
      </Grid>

      <Grid item xs={6} sm={3}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            textAlign: "center",
            borderRadius: "12px",
            backgroundColor: "rgba(255, 99, 132, 0.9)",
            color: "white",
          }}
        >
          <BadgeIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {new Set(people.map((p) => p.grade_id).filter(Boolean)).size}
          </Typography>
          <Typography variant="body2">Grade Levels</Typography>
        </Paper>
      </Grid>

      <Grid item xs={6} sm={3}>
        <Paper
          elevation={2}
          sx={{
            p: 2,
            textAlign: "center",
            borderRadius: "12px",
            backgroundColor: "rgba(153, 102, 255, 0.9)",
            color: "white",
          }}
        >
          <SchoolIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {new Set(people.map((p) => p.level).filter(Boolean)).size}
          </Typography>
          <Typography variant="body2">Role Levels</Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default StatsCards;
